import React from 'react';
import classnames from 'classnames';
import { Button } from 'tea-component';
import GPSelectMultiple from '@gp/components/SelectMultiple';
import AutoTextarea from '@gp/components/AutoTextarea';
import GeneralImageNew from '@gp/components/GeneralImageNew';
import { ActionItemStatusTag } from '@gp/components/StatusTag';
import { getTencentAvatarSrc } from '@gp/utils/common';
import {
  // CONSTANT_TEXTS,
  SELECT_PANEL_HEIGHT_WITHOUT_SEARCH_BOX,
  ACTION_ITEM_STATUS_OPTIONS,
} from '@gp/constants/const';

export const getColumns = (
  userIsAbleEdit: boolean,
  selectStatus: string[],
  handleStatusFilterChange: (value: string[]) => void,
  phaseOptions: IGPSelectOptionWithGroup[],
  selectPhase: string[],
  handlePhaseFilterChange: (value: string[]) => void,
  onEdit?: (cvm: any) => void,
) => {
  // 14 16 48 22
  const reviewColumns = [
    {
      key: 'due_date',
      header: 'DUE',
      align: 'left',
      width: '14%',
      render: (cvm: any) => cvm?.due_date || '-',
    },
    {
      key: 'status',
      header: (
        <GPSelectMultiple
          // 复用tea已有的改写样式
          className={classnames({
            'dbg-action-items-list-table-filter tea-table__filterbtn': true,
            'is-active': selectStatus?.length > 0,
          })}
          overlayClassName="dbg-action-items-list-table-common-status-filter-overlay"
          // label=""
          appearance="filter"
          matchButtonWidth={false}
          listHeight={SELECT_PANEL_HEIGHT_WITHOUT_SEARCH_BOX}
          listWidth={160}
          staging={false}
          searchable={false}
          clearable={false}
          disabled={false}
          allOption={{
            text: 'All',
            value: 'all',
          }}
          // groups={{separated: CONSTANT_TEXTS.SELECT_SEPARATED_GROUP_NAME}}
          options={ACTION_ITEM_STATUS_OPTIONS}
          button={<span className="tea-text-overflow">Status</span>}
          value={selectStatus}
          onChange={handleStatusFilterChange}
        />
      ),
      align: 'left',
      width: '16%',
      render: (cvm: any) => (
        <div className="dbg-action-items-list-status-item">
          <ActionItemStatusTag status={cvm?.status} />
        </div>
      ),
    },
    {
      key: 'action_items',
      header: 'Action Items',
      align: 'left',
      // width: '48%',
      render: (cvm: any) => (
        <AutoTextarea className="custom-text-area" readOnly defaultValue={cvm?.comment || '-'} />
      ),
    },
    // {
    //   key: 'phase',
    //   header: (
    //     <GPSelectMultiple
    //       // 复用tea已有的改写样式
    //       className={classnames({
    //         'dbg-action-items-list-table-filter tea-table__filterbtn': true,
    //         'is-active': selectPhase?.length > 0,
    //       })}
    //       overlayClassName="dbg-action-items-list-table-common-phase-filter-overlay"
    //       // label=""
    //       appearance="filter"
    //       placementOffset={[-210, 5]}
    //       matchButtonWidth={false}
    //       listHeight={SELECT_PANEL_HEIGHT_WITHOUT_SEARCH_BOX}
    //       listWidth={280}
    //       staging={false}
    //       searchable={false}
    //       clearable={false}
    //       disabled={false}
    //       allOption={{
    //         text: 'All',
    //         value: 'all',
    //       }}
    //       // groups={{separated: CONSTANT_TEXTS.SELECT_SEPARATED_GROUP_NAME}}
    //       options={phaseOptions}
    //       button={<span className="tea-text-overflow">Phase</span>}
    //       value={selectPhase}
    //       onChange={handlePhaseFilterChange}
    //     />
    //   ),
    //   align: 'left',
    //   width: '22%',
    //   render: (cvm: any) => {
    //     return <p>{cvm?.milestone || '-'}</p>;
    //   },
    // },
    {
      key: 'phase',
      header: 'Owner',
      align: 'left',
      width: '14%',
      render: (cvm: any) => {
        const userName = cvm?.user_name || '';
        return (
          <div className="custom-phase-flex">
            {/* <GeneralImageNew
              domain="user"
              src={'https://ogdb-cdn.intlgame.cn/image/7e2465d39f344c0cff3af1d77ceea8ab.jpg'}
              className="custom-phase-flex-img"
            /> */}
            {!!userName && (
              <GeneralImageNew
                className="custom-phase-flex-img"
                domain="user"
                width={24}
                height={24}
                src={getTencentAvatarSrc(userName)}
              />
            )}
            <span className="custom-phase-flex-text">{userName || '-'}</span>
          </div>
        );
      },
    },
  ];

  if (userIsAbleEdit) {
    reviewColumns.push({
      key: 'act',
      header: 'Action',
      align: 'left',
      // @ts-ignore
      width: 100,
      render: (cvm: any) => (
        <div className="dbg-actions-button">
          <Button
            style={{ padding: 0, textAlign: 'left' }}
            type="text"
            htmlType="button"
            onClick={() => {
              onEdit?.(cvm);
            }}
          >
            Edit
          </Button>
        </div>
      ),
    });
  }

  return reviewColumns;
};
